import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/home'
import Solution from '@/views/solution'
import TechnicalSupport from '@/views/technicalSupport'
import News from '@/views/news'
import About from '@/views/about'
import newsDetail from '@/views/newsdetail'

Vue.use(VueRouter)
const routes=[
  {
    path: '/',
    name: 'home',
    component: Home
  } ,
  {
    path: '/home',
    name: 'home',
    component: Home
  } ,
  {
    path: '/solution',
    name: 'solution',
    component:Solution
  } ,
  {
    path: '/tSupport',
    name: 'tSupport',
    component: TechnicalSupport
  } ,
  {
    path: '/news',
    name: 'news',
    component: News
  } ,
  {
    path: '/news/detail', //新闻详情
    name: 'newsdetail',
    component: newsDetail
  },
  {
    path: '/about',
    name: 'about',
    component: About
  } ,
  {
    // 路径错误时访问首页
    path: '*',
    component: Home
  }
];

const router = new VueRouter({
  mode: 'hash',//对比hash模式路由更美观无#
  base: process.env.BASE_URL,
  routes
})
export default router
